module.exports = __webpack_public_path__ + "static/img/ai-send.942baac1.png";